<dx-popup *ngIf="__bConfirmationVisible"
          [wrapperAttr]="{ class: __sCSSClass }"
          id="ppAlert"
          [width]="500"
          [(height)]="__iPopupHeight"
          [showTitle]="true"
          [dragEnabled]="false"
          title="{{__sMessageTitle}}"
          [hideOnOutsideClick]="true"
          [animation]="{ hide: { type: 'slideOut', direction: 'center', duration: 100 }, show: {type: 'slideIn', direction: 'center', duration: 100 }}"
          [(visible)]="__bConfirmationVisible">
  <div *dxTemplate="let data = data of 'content'">

    <div class="row message-border">
      <div class="col-lg-12 col-md-12 col-xs-12 message-box">
        <span>{{__sMessage}}</span>
      </div>
    </div>

    <div class="row" style="margin: 0px; ">
      <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
        <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
          <dx-button id="btnOk" (onClick)="Confirmation_Click()" text="Ok"></dx-button>
        </div>
      </div>
    </div>

  </div>
</dx-popup>
